import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";

// Este guard es cosmetico: evita enseñar una pantalla que no corresponde.
// La proteccion real de los datos son las politicas RLS del servidor, que se
// aplican aunque alguien manipule el JavaScript del navegador.

type RequireRoleProps = {
  rol: "admin" | "terapeuta";
  children: ReactNode;
};

const RequireRole = ({ rol, children }: RequireRoleProps) => {
  const { user, loading, roles, roleLoading } = useAuth();

  if (loading || roleLoading) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" aria-hidden="true" />
        <span className="sr-only">Cargando</span>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/acceso" replace />;
  }

  if (!roles.includes(rol)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default RequireRole;
